import React, { useState } from 'react';

const ElectiveSelector = ({ studentId, studentName, currentElectives, onElectiveChange }) => {
  const [selectedX1, setSelectedX1] = useState(currentElectives?.[0] || '');
  const [selectedX2, setSelectedX2] = useState(currentElectives?.[1] || '');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const x1Options = ['生物', '化學', '物理', '歷史', '地理'];
  const x2Options = ['生物', '化學', '物理', '歷史', '數學延伸'];

  const handleSubmit = async () => {
    if (!selectedX1 || !selectedX2) {
      alert('請選擇兩個選修科目');
      return;
    }

    setIsSubmitting(true);
    try {
      await onElectiveChange(studentId, [selectedX1, selectedX2]);
    } catch (error) {
      console.error('Error updating electives:', error);
      alert('更新選修科目時發生錯誤，請重試');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-4 mb-4">
      <h4 className="text-lg font-semibold mb-4">
        🎯 選修科目選擇 - {studentName}
      </h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">X1 選修科目</label>
          <select
            value={selectedX1}
            onChange={(e) => setSelectedX1(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            disabled={isSubmitting}
          >
            <option value="">請選擇科目</option>
            {x1Options.map(option => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">X2 選修科目</label>
          <select
            value={selectedX2}
            onChange={(e) => setSelectedX2(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            disabled={isSubmitting}
          >
            <option value="">請選擇科目</option>
            {x2Options.map(option => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </div>
      </div>
      <div className="mt-4 flex items-center justify-between">
        <div className="text-sm text-gray-600">
          {currentElectives && currentElectives.length > 0 && (
            <span>目前選修: {currentElectives.join(', ')}</span>
          )}
        </div>
        <button
          onClick={handleSubmit}
          disabled={!selectedX1 || !selectedX2 || isSubmitting}
          className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center"
        >
          {isSubmitting && (
            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          )}
          {isSubmitting ? '更新中...' : '確認選擇'}
        </button>
      </div>
    </div>
  );
};

export default ElectiveSelector;
